<template>
  <div class="ticketsView main_view">
    <header-comp/>
    <div class="view_grid">
      <navbar-comp :active="'tickets'" class="navbar"/>
      <tickets-comp v-if="show == 'all'"/>
      <ticket-comp v-if="show == 'one'"/>
      <ticket-new-crud-comp v-if="show == 'new'"/>
    </div>
  </div>
</template>

<script>
import httpService from '../http'
import api from '../api'

export default {
  name: 'ticketsView',
  components: {},
  props: {
    id: {
      type: String,
      default: () => null
    }
  },
  data: function () {
    return {
      moduleName: 'tickets'
    }
  },
  computed: {
    show: function () {
      return this.$store.getters[`${this.moduleName}/getShow`]
    },
    role: function () {
      return localStorage.getItem('role')
    }
  },
  beforeCreate: function () {
  },
  created: function () {
    if (this.id) this.getOne(this.id)
  },
  methods: {
    async getOne (id) {
      let t = await httpService.get(api.tickets[this.role].getOne, { id })
      if (t && t.data && t.data.data && t.data.data.user && t.data.data.user.id) {
        this.$store.commit(`${this.moduleName}/setUserId`, t.data.data.user.id)
        this.$store.dispatch(`${this.moduleName}/toUpdate`, { id })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
